export default __webpack_public_path__ + "static/16-d2745da8d0ad983248f0fd2c2ae13b8d.png";